import {
    CardState,
    FormData,
    FormResponse,
    LoadFormDataResponse,
    SetInputData,
    TechTaskState
} from '@/dynamic-tech-task/types'
import Vuex, { ActionContext } from 'vuex'
import { InputType } from '@/components/ui/DynamicTechTaskCard/types'
import request from '@/helpers/requests'
import Vue from 'vue'


Vue.use(Vuex)

export default {
    state: {
        taskName: null,
        cardState: CardState.FORM_LOADING,
        message: null,
        form: null,
        inputData: {},
        displayData: null
    } as TechTaskState,
    getters: {
        displayFields: (state: TechTaskState) => {
            return state.form?.displayFields
        },
        inputFields: (state: TechTaskState) => {
            return state.form?.inputFields
        }
    },
    actions: {
        async setInputData(context: ActionContext<TechTaskState, unknown>, payload: SetInputData): Promise<void> {
            context.commit('setInputData', payload)
        },
        async setDisplayData(context: ActionContext<TechTaskState, unknown>, displayData: { [key: string]: unknown }|null): Promise<void> {
            context.commit('setDisplayData', displayData)
        },
        async loadForm(context: ActionContext<TechTaskState, unknown>, taskName: string) {
            context.commit('setTaskName', taskName)
            context.commit('setCardState', {
                cardState: CardState.FORM_LOADING
            })
            context.commit('resetData')
            context.commit('setForm', null)
            try {
                const response: FormResponse = await request.post(`/support-form/${context.state.taskName}`) as FormResponse
                context.commit('setForm', response.data)
                await context.dispatch('resetInputFields')
                context.commit('setCardState', {
                    cardState: CardState.READY
                })
            } catch(e) {
                context.commit('setCardState', {
                    cardState: CardState.FORM_ERROR
                })
            }
        },
        resetInputFields(context: ActionContext<TechTaskState, unknown>) {
            for (const inputField of context.getters.inputFields) {
                if (inputField.inputType === InputType.PULSEM_ACCOUNT_ID) {
                    if (!context.state.inputData[inputField.key]) {
                        context.commit('setInputData', {
                            key: inputField.key,
                            value: null
                        })
                    }
                } else {
                    if (inputField.inputType === InputType.CHECKBOX) {
                        context.commit('setInputData', {
                            key: inputField.key,
                            value: inputField.inputOptions.defaultValue
                        })
                    } else if (inputField.inputType === InputType.COMBOBOX) {
                        context.commit('setInputData', {
                            key: inputField.key,
                            value: []
                        })
                    } else {
                        context.commit('setInputData', {
                            key: inputField.key,
                            value: null
                        })
                    }
                }
            }
        },
        async formLoadData(context: ActionContext<TechTaskState, unknown>) {
            try {
                if (context.state.form?.behavior.loadData) {
                    const requestPayload: { [key: string]: unknown } = {}
                    for (const key of context.state.form?.behavior.loadData) {
                        requestPayload[key] = context.state.inputData[key]
                        if (requestPayload[key] === null) {
                            return
                        }
                    }
                    context.commit('setCardState', {
                        cardState: CardState.LOADING,
                        message: null
                    })
                    const response = await request.post(`/form-data/${context.state.taskName}`, requestPayload) as LoadFormDataResponse
                    for (const key in response.data) {
                        context.commit('setInputData', {
                            key,
                            value: response.data[key]
                        })
                    }
                    context.commit('setCardState', {
                        cardState: CardState.READY
                    })
                }
            } catch(e) {
                context.commit('setCardState', {
                    cardState: CardState.ERROR,
                    message: e.message
                })
            }
        }
    },
    mutations: {
        resetData(state: TechTaskState) {
            Vue.set(state, 'inputData', {})
            Vue.set(state, 'displayData', {})
        },
        setForm(state: TechTaskState, form: FormData|null) {
            state.form = form
        },
        setInputData(state: TechTaskState, payload: SetInputData) {
            Vue.set(state.inputData, payload.key, payload.value)
        },
        setDisplayData(state: TechTaskState, displayData: { [key: string]: unknown }|null) {
            Vue.set(state, 'displayData', displayData)
        },
        setCardState(state: TechTaskState, details: { cardState: CardState; message?: string|null }) {
            Vue.set(state, 'cardState', details.cardState)
            if ('message' in details) {
                Vue.set(state, 'message', details.message)
            }
        },
        setTaskName(state: TechTaskState, taskName: string) {
            state.taskName = taskName
        }
    }
}
